import * as React from 'react';

export function syntheticEvent(): React.SyntheticEvent {
  return expect.objectContaining({
    preventDefault: expect.any(Function),
    type: 'click',
  });
}
